import { useEffect } from "react";
import { Chart as ChartJS } from "chart.js";
import { useThemeMode } from "./ThemeModeContext";

/**
 * Chart.js paints to canvas, where var() is not a valid colour, so token values
 * have to be resolved to literals and re-applied whenever the theme flips.
 */
const readToken = (name, fallback) => {
  if (typeof document === "undefined") return fallback;
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
  return value || fallback;
};

export const useChartTheme = () => {
  const { resolvedTheme } = useThemeMode();

  useEffect(() => {
    ChartJS.defaults.color = readToken("--color-ui-text-muted", "#6b7280");
    ChartJS.defaults.borderColor = readToken("--color-ui-border", "#e5e7eb");
    ChartJS.defaults.scale.grid.color = readToken(
      "--color-ui-border-subtle",
      "#f3f4f6",
    );

    // Existing charts keep their old palette until told to redraw.
    Object.values(ChartJS.instances || {}).forEach((chart) => chart.update());
  }, [resolvedTheme]);
};
